export const RASTER_TILEJSON = "https://tiles.openstreetmap.us/raster/wetlands.json";
export const VECTOR_TILEJSON = "https://tiles.openstreetmap.us/vector/wetlands.json";
export const SOURDOUGH_TILEJSON = "https://tiles.openstreetmap.us/vector/sourdough.json";
export const HILLSHADE_TILEJSON = "https://tiles.openstreetmap.us/raster/hillshade.json";
export const GLYPHS = "https://tiles.openstreetmap.us/fonts/{fontstack}/{range}.pbf";

export const OSM_API = "https://api.openstreetmap.org/api/0.6";
export const OSM_SITE = "https://www.openstreetmap.org";
export const OSM_WIKI = "https://wiki.openstreetmap.org/wiki";

export const LAYERCAKE_METADATA = "https://data.openstreetmap.us/layercake/metadata.json";
export const EXPLORER_URL = "https://layercake.openstreetmap.us/explore/";

export const WETLAND_SOURCE_LAYER = "wetland";
export const INTERACTIVE_MIN_ZOOM = 12;

export const DEFAULT_VIEW = { lng: -100, lat: 38, zoom: 3.5 };
